import { render } from "./Kelurahan.vue?vue&type=template&id=597eccde"
import script from "./Kelurahan.vue?vue&type=script&lang=js"
export * from "./Kelurahan.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__